import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { MyProjectsContainerTemplate as template } from './my-projects.template';
import { MyProjectsContainerStyles as styles } from './my-projects.styles';
import { IAllProjects, Project } from '../../../../types';
import { logger, Message, SocketSubscription } from '@genesislcap/foundation-comms';
import { IProjectService } from '../../../../services';
import { updateArray } from '../../../../utils/dataserver';
import { Tabs } from '@microsoft/fast-foundation';
import { ICompanyService } from '../../../../services/company.service';
import { COMPANY_ROLE } from '../../../mf/companys/edit';

const name = 'my-projects-container';

@customElement({
  name,
  template,
  styles,
})
export class MyProjectsContainer extends FASTElement {
  @IProjectService projectService: IProjectService;
  @ICompanyService companyService: ICompanyService;
  @observable selectedProject: IAllProjects;
  @observable projectList: Array<IAllProjects> = [];

  @observable selectedDraftProject: Project;
  @observable draftProjectList: Array<Project> = [];

  public modalTabs: Tabs;

  private projectSubscription: SocketSubscription;
  private draftProjectSubscription: SocketSubscription;

  connectedCallback() {
    super.connectedCallback();
    this.streamProjects();
    this.streamDraftProjects();
  }

  isProjectListEmpty(): boolean {
    return this.projectList.length === 0;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.projectSubscription?.unsubscribe();
    this.draftProjectSubscription?.unsubscribe();
  }

  private streamProjects() {
    let resultList = [];
    const matchCriteria =
      this.companyService.getCurrentCompany().COMPANY_ROLE === COMPANY_ROLE.CASCADE_ADMIN
        ? ''
        : `CASCADE_COMPANY_ID == '${this.companyService.getCurrentCompany().CASCADE_COMPANY_ID}'`;

    this.projectSubscription = this.projectService.getAllProjects(matchCriteria).subscribe({
      next: (streamMessage: Message) => {
        resultList = streamMessage.ROW ?? null;
        if (resultList) {
          this.projectList = updateArray(resultList, this.projectList).sort(
            (a, b) => b.MODIFIED_AT - a.MODIFIED_AT,
          );
          this.$emit('listProjects', this.projectList);
          this.$emit('noProjects', this.projectList);

          if (
            this.selectedProject &&
            resultList.find((el) => this.selectedProject['DETAILS'].ROW_REF === el.DETAILS.ROW_REF)
          ) {
            const projectId = this.selectedProject.PROJECT_ID;
            this.selectedProject = this.projectList.find((x) => x.PROJECT_ID === projectId);

            this.$emit('projectSelected', this.selectedProject);
          }
        } else {
          this.projectList = [];
          this.$emit('noProjects', this.projectList);
        }
      },
      error: (error: any) => {
        this.projectList = [];
        logger.error(error);
      },
    });
  }

  public toggleSelectProject(project: IAllProjects) {
    if (!this.selectedProject || this.selectedProject.PROJECT_ID !== project.PROJECT_ID) {
      this.selectedProject = project;
      this.$emit('projectSelected', this.selectedProject);
      this.$emit('hasProjectEvent', this.projectList.length > 0);
    } else {
      this.selectedProject = null;
      this.$emit('projectSelected', false);
      this.$emit('hasProjectEvent', false);
    }
  }

  private streamDraftProjects() {
    let resultList = [];
    this.draftProjectSubscription = this.projectService.getAllDraftProjects('').subscribe({
      next: (streamMessage: Message) => {
        resultList = streamMessage.ROW ?? null;
        if (resultList) {
          this.draftProjectList = updateArray(resultList, this.draftProjectList).sort(
            (a, b) => b.MODIFIED_AT - a.MODIFIED_AT,
          );
        } else {
          this.draftProjectList = [];
        }
      },
      error: (error: any) => {
        this.draftProjectList = [];
        logger.error(error);
      },
    });
  }
}
